// Test IDs registry (kebab-case values).

export const AUTH = {
  companyInput: 'auth-company-input',
  nameInput: 'auth-name-input',
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  submitButton: 'auth-submit-button',
  switchModeButton: 'auth-switch-mode-button',
};

export const NAV = {
  logo: 'nav-logo',
  dashboard: 'nav-dashboard',
  inbox: 'nav-inbox',
  leads: 'nav-leads',
  pipeline: 'nav-pipeline',
  scheduler: 'nav-scheduler',
  chatbot: 'nav-chatbot',
  analytics: 'nav-analytics',
  divisions: 'nav-divisions',
  settings: 'nav-settings',
  logoutButton: 'nav-logout-button',
  divisionSwitcher: 'nav-division-switcher',
};

export const INBOX = {
  simulateButton: 'inbox-simulate-button',
  conversationItem: 'inbox-conversation-item',
  replyInput: 'inbox-reply-input',
  replySend: 'inbox-reply-send',
  internalNoteToggle: 'inbox-internal-note-toggle',
  categorySelect: 'inbox-category-select',
  statusSelect: 'inbox-status-select',
  simulateSubmit: 'inbox-simulate-submit',
};

export const LEADS = {
  card: 'leads-card',
  convertButton: 'leads-convert-button',
  disqualifyButton: 'leads-disqualify-button',
  convertSubmit: 'leads-convert-submit',
  disqualifySubmit: 'leads-disqualify-submit',
  reactivateButton: 'leads-reactivate-button',
};

export const PIPELINE = {
  column: 'pipeline-column',
  card: 'pipeline-card',
  addStageButton: 'pipeline-add-stage-button',
};

export const DEAL = {
  addActivity: 'deal-add-activity',
  moveStage: 'deal-move-stage',
};

export const CHATBOT = {
  uploadInput: 'chatbot-upload-input',
  saveConfig: 'chatbot-save-config',
  sendMessage: 'chatbot-send-message',
  messageInput: 'chatbot-message-input',
};

export const SCHED = {
  addTypeButton: 'sched-add-type-button',
  saveAvailability: 'sched-save-availability',
};

export const DIV = {
  createButton: 'div-create-button',
  createSubmit: 'div-create-submit',
};
